import { Trans, t } from "@lingui/macro";
import { ethers } from "ethers";
import { useState } from "react";
import { useParams } from "react-router-dom";

import { BOTANIX } from "config/chains";
import { APP_NAME } from "config/ui";
import { usePendingTxns } from "context/PendingTxnsContext/PendingTxnsContext";
import { registerReferralCode, useReferralsData } from "domain/referrals";
import { useChainId } from "lib/chains";
import { getPageTitle } from "lib/legacy";
import useWallet from "lib/wallets/useWallet";

import Loader from "components/Common/Loader";
import SEO from "components/Common/SEO";
import Footer from "components/Footer/Footer";
import PageTitle from "components/PageTitle/PageTitle";
import AddAffiliateCode from "components/Referrals/AddAffiliateCode";
import AffiliatesStats from "components/Referrals/AffiliatesStats";

import "./Referrals.css";

function Referrals() {
  const { active, account: walletAccount, signer } = useWallet();
  const { account: queryAccount } = useParams<{ account?: string }>();
  const [selectedTable, setSelectedTable] = useState<string>("referrals");
  let account;
  if (queryAccount && ethers.isAddress(queryAccount)) {
    account = ethers.getAddress(queryAccount);
  } else {
    account = walletAccount;
  }
  const { chainId } = useChainId();
  const { data: referralsData, loading, refresh: refreshReferralsData } = useReferralsData(account, chainId, false);
  const { pendingTxns } = usePendingTxns();

  function handleCreateReferralCode(referralCode) {
    return registerReferralCode(chainId, referralCode, signer, {
      sentMsg: t`Referral code submitted!`,
      failMsg: t`Referral code creation failed.`,
      pendingTxns,
    });
  }

  const isBotanix = chainId === BOTANIX;

  function renderAffiliatesTab() {
    if (loading && !referralsData) return <Loader />;
    if (account) {
      return (
        <AffiliatesStats
          referralsData={referralsData}
          handleCreateReferralCode={handleCreateReferralCode}
          onReferralCodeCreated={refreshReferralsData}
          chainId={chainId}
          referralAccount={account}
          selectedTable={selectedTable}
          onSelectedTableChange={setSelectedTable}
        />
      );
    } else {
      return <AddAffiliateCode handleCreateReferralCode={handleCreateReferralCode} active={active} />;
    }
  }

  return (
    <SEO title={getPageTitle(t`Referrals`)}>
      <div className="default-container page-layout Referrals">
        <PageTitle
          isTop
          title={t`Referrals`}
          hasMaxWidth={false}
          hasBackButton
          subtitle={
            !isBotanix ? (
              <Trans>
                Get fee discounts and earn rebates through the {APP_NAME} referral program.
                {/* <br />
                For more information, please read the{" "}
                <ExternalLink href="https://docs.gmx.io/docs/referrals">referral program details</ExternalLink>. */}
              </Trans>
            ) : undefined
          }
          qa="referrals-page"
        />
        {renderAffiliatesTab()}
      </div>
      <Footer />
    </SEO>
  );
}

export default Referrals;
